module.exports = __webpack_public_path__ + "media/site_templates/www.localhousepainters.com.au/images/splash-37eeeb4189ee75506ec4681cab5d646a.jpeg";